import { createFileRoute } from '@tanstack/react-router';
import { ForecastOccurrenceForm } from '@/pages/forecast/occurrence/form';
import { FORECAST, PROTECTED } from '@/lib/constants/routes';
import { createSheetRouteOptions } from '@/components/molecules/sheet-view-loader/route-helpers';

const RETURN_URL = `${PROTECTED}${FORECAST}`;

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/forecast/$id'
)({
  ...createSheetRouteOptions(RETURN_URL),
  component: EditOccurrenceModal,
});

function EditOccurrenceModal() {
  const { id } = Route.useParams();
  return <ForecastOccurrenceForm id={id} returnUrl={RETURN_URL} />;
}
